import { createFeatureSelector, createSelector, MemoizedSelector } from "@ngrx/store";
import { IRoundState, RoundState } from "./interfaces";
import { ERoundState, IRound, IRoundBet, IRoundGetStateData } from "../interfaces";
import { betsAdapter } from "./round.reducers";

export const selectRoundState: MemoizedSelector<IRoundState, IRoundState> = createFeatureSelector(RoundState.featureKey);
export const selectRoundId: MemoizedSelector<IRoundState, string | undefined> = createSelector(selectRoundState, (roundState: IRoundState) => {
    return roundState.roundId;
});
export const selectTotalBetsCount: MemoizedSelector<IRoundState, number> = createSelector(selectRoundState, (roundState: IRoundState) => {
    return roundState.totalBets;
});
export const selectRoundCurrentState: MemoizedSelector<IRoundState, ERoundState> = createSelector(selectRoundState, (roundState: IRoundState) => {
    return roundState.state;
});
export const betsSelectors = betsAdapter.getSelectors(createSelector(selectRoundState, s1 => s1.bets));
export const selectRoundBets: MemoizedSelector<IRoundState, IRoundBet[]> = createSelector(betsSelectors.selectAll, (bets: IRoundBet[]) => {
    return bets;
});
export const selectRoundMultiplier: MemoizedSelector<IRoundState, number> = createSelector(selectRoundState, (roundState: IRoundState) => {
    return roundState.multiplier;
});
export const selectRoundInitialState: MemoizedSelector<IRoundState, IRoundGetStateData | undefined> = createSelector(selectRoundState, (roundState: IRoundState) => {
    return roundState.initialRoundState;
});

export const selectRoundAllData: MemoizedSelector<IRoundState, IRound> = createSelector(selectRoundState, selectRoundBets, (roundState: IRoundState, bets: IRoundBet[]) => {
    return {
        ...roundState,
        bets
    };
});
